import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { CustomerFacade } from '@ridango/components';
import Env from '@ridango/core/env';

@Component({
    templateUrl: './account-edit-page.component.html',
    styleUrls: ['./account-edit-page.component.scss']
})
export class AccountEditPageComponent implements OnInit {
    constructor(
        @Inject('ENV') public env: Env,
        private translate: TranslateService,
        private router: Router,
        private customerFacade: CustomerFacade
    ) {}

    ngOnInit() {
        this.customerFacade.setCustomerFields(this.getAccountDetailFields(this.env.ACCOUNT.FORMFIELDS));
    }

    back() {
        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
    }

    handleEditSuccess() {
        this.router.navigate([this.translate.currentLang, 'account', 'profile']);
    }

    getAccountDetailFields(envDetails) {
        const detailFields = [];

        envDetails.forEach((formField) => {
            detailFields.push(formField.toLowerCase());
        });

        return detailFields;
    }
}
